import { createSlice} from '@reduxjs/toolkit';
import { RootState } from '..';

export interface vehicleCategory {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: vehicleCategory = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const vehicleCategorySlice = createSlice({
  name: 'vehicleCategory',
  initialState,
  reducers: {
    setVehicleCategory: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

export const { setVehicleCategory, reset } = vehicleCategorySlice.actions;

export const addVehicleCategory = (state: RootState) => state.vehicleCategory.data;
export const getVehicleCategoryTotalRecord = (state: RootState) => state.vehicleCategory.totalRecords;
export default vehicleCategorySlice.reducer;
